import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_CUSTOMER = requestConstantsMaker('GET_ALL_CUSTOMER');
export const GET_CUSTOMER = requestConstantsMaker('GET_CUSTOMER');
export const CREATE_CUSTOMER = requestConstantsMaker('CREATE_CUSTOMER');
export const UPDATE_CUSTOMER = requestConstantsMaker('UPDATE_CUSTOMER');
export const GET_CUSTOMERS_FOR_SELECTION = requestConstantsMaker('GET_CUSTOMERS_FOR_SELECTION');
/**** 20200217 ****/

export const GET_ALL_CUSTOMER_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_CUSTOMER_BY_SPECIFICATION');
// export const GET_ALL_CUSTOMER = requestConstantsMaker('GET_ALL_CUSTOMER');
export const GET_CUSTOMER_BY_ID = requestConstantsMaker('GET_CUSTOMER_BY_ID');
export const POST_CREATE_CUSTOMER = requestConstantsMaker('POST_CREATE_CUSTOMER');
export const PUT_UPDATE_CUSTOMER = requestConstantsMaker('PUT_UPDATE_CUSTOMER');